import type {
  IIncludedProduct,
  InstallmentPlanPricing,
  IMoney,
  IProduct,
  IRecommendedAddonProduct,
  ISoftwarePlan,
  ITransactionRate,
} from 'services/dcs/bundle';

export enum OrderType {
  BUNDLE = 'BUNDLE',
  BYO = 'BYO',
}

export interface ICartPricing {
  id: string;
  name: string;
  basePrice: IMoney;
  baseMonthlyPrice: IMoney;
  monthlyAdditionalPrice: IMoney;
  additionalDevicePrice?: IMoney;
  installmentPlans: InstallmentPlanPricing;
  keyedInRate: ITransactionRate;
  inPersonRate: ITransactionRate;
  msrp: IMoney | null;
  softwarePlan: ISoftwarePlan;
  includedProducts: IIncludedProduct[];
  recommendedAddons: IRecommendedAddonProduct[];
  isSelfServicePurchaseEnabled?: boolean;
  orderType: OrderType;
}

export interface IProductPricing {
  id: string;
  name: string;
  basePrice: IMoney;
  installmentPlans: InstallmentPlanPricing;
  msrp: IMoney | null;
  fdmpId: string;
  isSelfServicePurchaseEnabled?: boolean;
  accessories?: IProduct[];
}

export interface IProductsWithSoftwarePlan {
  products: Array<{ id: string; quantity: number }>;
  planId: string;
}
export interface IDcsPricingQuery {
  bundleIds?: string[];
  productIds?: string[];
  productsWithSoftwarePlan?: IProductsWithSoftwarePlan[];
}
